// ===========================================
// METHOD 3: Fixed Books Per Page from Config
// ===========================================

// hooks/useResponsivePagination.js
import { useState } from 'react';
import { PAGINATION_CONFIG } from '../utils/constants';

export const useResponsivePagination = () => {
  // Use books per page from configuration
  const [booksPerPage] = useState(PAGINATION_CONFIG.BOOKS_PER_PAGE);

  return booksPerPage;
};